import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/profile/arrow_right_white45.png'


const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "menu-left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "menu-text" }
const _hoisted_5 = {
  key: 0,
  class: "sub_text"
}
const _hoisted_6 = {
  key: 1,
  class: "sub_text"
}
const _hoisted_7 = {
  key: 0,
  class: "unreadCount"
}

import { ref, inject, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user';
import { clickOnMenuThemeFour, MENU_LIST_THEME_FOUR, SUPPORT_CHAT_MENU, clickOnCard } from '@/view/profile/supportScript'
import { useActivityStore } from '@/stores/activity'

interface MenuItem {
  name: string
  img: any
  path: string | null
  msg?: string
  isHaveIcons?: boolean
  isSupport?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'menuCard',
  props: {
    isSupportChatMenu: {
        type: Boolean,
        default: () => false
    }
},
  emits: ['logout'],
  setup(__props, { emit: __emit }) {

const activityStore = useActivityStore()
const router = useRouter()
const contactServiceRef = ref()
const poppingIndex = ref<number | null>(null)
const emits = __emit
const openLogoutPopup = inject<() => void>('openLogoutPopup')
const userStore = useUserStore()
const unreadMsgCount = computed(() => userStore.unreadCount)
const isPopping = ref(false)

const menuList = computed<MenuItem[]>(() => {
  if (props.isSupportChatMenu) {
    return SUPPORT_CHAT_MENU
  }
  return MENU_LIST_THEME_FOUR
})

const props = __props

const handleLogoutClick = () => {
  openLogoutPopup?.()
}

const onMenuClick = (path: string | null, index: number) => {
  if (props.isSupportChatMenu) {
    clickOnCard(router, isPopping, '/sd-message')
    return
  } else {
    clickOnMenuThemeFour(router, poppingIndex, contactServiceRef, handleLogoutClick, path, index)
  }
}

const checkMenuShow = (index: number) => {
  if (index === 2) {
    const isAvailableRedeem = activityStore.activityList.some((obj: any) => obj.name === "redeem_code")
    if (isAvailableRedeem) {
      return true
    } else {
      return false
    }
  }

  return true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "menu-section",
    style: _normalizeStyle({marginBottom: !props.isSupportChatMenu ? '0' : '10px'})
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (checkMenuShow(index))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "menu-card",
              style: _normalizeStyle({margin: !props.isSupportChatMenu ? '25px 5px' : '8px 5px 5px'}),
              onClick: ($event: any) => (onMenuClick(item.path, index))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: item.img,
                  alt: "",
                  class: "menu-icon"
                }, null, 8, _hoisted_3),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(item.name)), 1),
                (item.msg && item.isHaveIcons)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString('🔴 '+ _ctx.$t(item.msg) +' 🎁'), 1))
                  : _createCommentVNode("", true),
                (item.msg && !item.isHaveIcons)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t(item.msg)), 1))
                  : _createCommentVNode("", true)
              ]),
              (item.isSupport && unreadMsgCount.value>0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(unreadMsgCount.value), 1))
                : _createCommentVNode("", true),
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: _imports_0,
                alt: "",
                class: "arrow-icon"
              }, null, -1))
            ], 12, _hoisted_1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 4))
}
}

})